import { lazy } from 'react';
import ContainerTypeForm from './ContainerTypeFrom';
import ContainerTypeList from './ContainerTypeList';

const ContainerTypeConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/containerType',
            element: <ContainerTypeList />,
        },
        {
            path: '/addContainerType',
            element: <ContainerTypeForm />,
        },
        {
            path: '/editContainerType/:id',
            element: <ContainerTypeForm />,
        },
    ],
};

export default ContainerTypeConfig;
